import { Pipe, PipeTransform } from '@angular/core';
import {
  SmsActions,
  UserRegistrationConfirmationTokenVaultActions,
  UserSmsTokenVaultActions,
  UserTwoFATokenVaultActions,
} from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'smsActionDisplay',
})
export class SmsActionDisplayPipe implements PipeTransform {
  transform(value: SmsActions): string {
    return smsActionDisplayTransform(value);
  }
}

export function smsActionDisplayTransform(value: SmsActions) {
  if (Object.values(UserSmsTokenVaultActions).includes(value as UserSmsTokenVaultActions)) {
    return CoreNiceLabelUtils.smsAction(value as UserSmsTokenVaultActions);
  }

  if (
    Object.values(UserRegistrationConfirmationTokenVaultActions).includes(
      value as UserRegistrationConfirmationTokenVaultActions,
    )
  ) {
    return CoreNiceLabelUtils.registrationAction(value as UserRegistrationConfirmationTokenVaultActions);
  }

  if (Object.values(UserTwoFATokenVaultActions).includes(value as UserTwoFATokenVaultActions)) {
    return CoreNiceLabelUtils.twoFAAction(value as UserTwoFATokenVaultActions);
  }

  return String(value);
}
